export default function useDateTimeMedium(dateString: string): string {
  return useDateFormat(dateString, 'dd MMM yyyy, HH:mm')
}
